// extracted by css-extract-rspack-plugin
export default {"UpsellGem":"QuLJt"};